type IconsPros = {
  type?: string
  className?: string
}

export default function Icon({ type, className }: IconsPros) {
  return (
    <>
      {type === 'check' && (
        <svg
          width="13"
          height="14"
          viewBox="0 0 13 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g id="yes 1" clipPath="url(#clip0_108_2114)">
            <path
              id="Vector"
              d="M6.50001 13.2835C9.9702 13.2835 12.7833 10.4703 12.7833 7.00013C12.7833 3.52994 9.9702 0.716797 6.50001 0.716797C3.02982 0.716797 0.216675 3.52994 0.216675 7.00013C0.216675 10.4703 3.02982 13.2835 6.50001 13.2835Z"
              fill="#404041"
            />
            <path
              id="Vector_2"
              d="M5.25678 9.61512L3.78345 8.17602C3.75158 8.14505 3.72625 8.10799 3.70895 8.06706C3.69165 8.02612 3.68274 7.98213 3.68274 7.93769C3.68274 7.89324 3.69165 7.84925 3.70895 7.80832C3.72625 7.76738 3.75158 7.73033 3.78345 7.69935L4.27203 7.22269C4.33755 7.1592 4.4252 7.1237 4.51643 7.1237C4.60766 7.1237 4.69531 7.1592 4.76083 7.22269L5.6379 8.08004L8.09772 4.34037C8.14847 4.26491 8.22658 4.21214 8.31553 4.19322C8.40448 4.17429 8.49731 4.1907 8.57438 4.23897L9.15592 4.60427C9.1939 4.62763 9.22681 4.65837 9.25268 4.69468C9.27856 4.73099 9.29688 4.77213 9.30656 4.81566C9.31624 4.85919 9.31708 4.90421 9.30903 4.94807C9.30098 4.99192 9.2842 5.03372 9.2597 5.07097L6.34705 9.5005C6.28869 9.58721 6.21202 9.66006 6.12246 9.71393C6.0329 9.7678 5.93261 9.80138 5.82867 9.81231C5.72473 9.82324 5.61965 9.81125 5.52085 9.77718C5.42204 9.74311 5.3319 9.68779 5.25678 9.61512Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_108_2114">
              <rect
                width="13"
                height="13"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
      {type === 'global' && (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g clipPath="url(#clip0_5_16315)">
            <path
              d="M8 0.5C6.51664 0.5 5.0666 0.939867 3.83323 1.76398C2.59986 2.58809 1.63856 3.75943 1.07091 5.12987C0.50325 6.50032 0.354725 8.00832 0.644114 9.46318C0.933503 10.918 1.64781 12.2544 2.6967 13.3033C3.7456 14.3522 5.08197 15.0665 6.53683 15.3559C7.99168 15.6453 9.49968 15.4968 10.8701 14.9291C12.2406 14.3614 13.4119 13.4001 14.236 12.1668C15.0601 10.9334 15.5 9.48336 15.5 8C15.4976 6.01163 14.7066 4.1054 13.3006 2.6994C11.8946 1.29341 9.98837 0.502448 8 0.5ZM1.26 6.11L1.54 6.52C1.5527 6.5381 1.55796 6.56038 1.55471 6.58224C1.55145 6.60411 1.53992 6.62389 1.5225 6.6375L1.2375 6.855C1.17175 6.90471 1.12641 6.97672 1.11 7.0575L1.02 7.4875C1.05215 7.02127 1.13258 6.55963 1.26 6.11ZM13.525 5.2475C13.5924 5.25067 13.6574 5.27407 13.7113 5.31465C13.7653 5.35522 13.8057 5.4111 13.8275 5.475L13.84 5.51C13.865 5.58638 13.9136 5.6529 13.9787 5.70004C14.0438 5.74718 14.1221 5.77255 14.2025 5.7725H14.635C14.6945 5.94232 14.7454 6.11504 14.7875 6.29L14.375 6.7025C14.3678 6.70968 14.3592 6.71537 14.3497 6.71923C14.3403 6.72309 14.3302 6.72505 14.32 6.725H13.705C13.6949 6.72501 13.685 6.72299 13.6757 6.71906C13.6664 6.71514 13.6581 6.70939 13.6511 6.70216C13.6441 6.69493 13.6386 6.68636 13.635 6.67697C13.6314 6.66758 13.6297 6.65756 13.63 6.6475C13.6301 6.58557 13.6125 6.52491 13.5793 6.47265C13.5461 6.42038 13.4986 6.3787 13.4425 6.3525C13.3867 6.32522 13.3241 6.31471 13.2625 6.32226C13.2008 6.3298 13.1426 6.35507 13.095 6.395L11.95 7.325C11.7494 7.48697 11.5878 7.69192 11.477 7.92471C11.3663 8.1575 11.3092 8.4122 11.31 8.67V9.5675C11.31 9.6102 11.3183 9.65249 11.3346 9.69195C11.3509 9.73142 11.3748 9.76728 11.405 9.7975L12.1975 10.5925C12.2598 10.6531 12.3431 10.6871 12.43 10.6875H12.73C12.8709 10.6878 13.0088 10.6471 13.1269 10.5703C13.245 10.4935 13.3382 10.3839 13.395 10.255L14.1725 11.3025C13.5741 12.4193 12.684 13.353 11.5971 14.0041C10.5102 14.6552 9.26703 14.9994 8 15C7.965 15 7.9325 15 7.8975 14.9975V14.9325C7.8975 14.8861 7.91594 14.8416 7.94876 14.8088C7.98158 14.7759 8.02609 14.7575 8.0725 14.7575C8.21088 14.7568 8.34339 14.7016 8.44124 14.6037C8.53909 14.5059 8.59435 14.3734 8.595 14.235V13.7725C8.59493 13.7284 8.61172 13.686 8.64194 13.6539C8.67216 13.6219 8.71351 13.6026 8.7575 13.6C8.84661 13.5939 8.93146 13.5596 8.99977 13.5021C9.06809 13.4445 9.11633 13.3668 9.1375 13.28C9.16123 13.1935 9.15627 13.1017 9.12336 13.0183C9.09045 12.9349 9.03137 12.8645 8.955 12.8175L7.6225 11.9675C7.59768 11.9518 7.5773 11.93 7.5633 11.9042C7.54929 11.8783 7.54213 11.8494 7.5425 11.82V11.5725C7.54184 11.4602 7.49677 11.3528 7.41714 11.2736C7.33751 11.1944 7.22979 11.15 7.1175 11.15H6.9025C6.77364 11.1493 6.65029 11.0977 6.5594 11.0063C6.46852 10.915 6.4175 10.7914 6.4175 10.6625C6.4175 10.6067 6.40651 10.5514 6.38515 10.4999C6.36379 10.4483 6.33249 10.4014 6.29302 10.362C6.25356 10.3225 6.20671 10.2912 6.15514 10.2699C6.10358 10.2485 6.04831 10.2375 5.9925 10.2375H4.0425C3.93022 10.2382 3.82276 10.2832 3.7436 10.3629C3.66443 10.4425 3.62 10.5502 3.62 10.6625V10.7925C3.62001 10.8347 3.60494 10.8755 3.5775 10.9075L3.135 11.425C3.07631 11.4936 3.04123 11.5792 3.03493 11.6692C3.02862 11.7593 3.05144 11.8489 3.1 11.925L3.39 12.3925C3.41131 12.4291 3.4393 12.4613 3.4725 12.4875L4.5325 13.4125C4.55106 13.4293 4.56597 13.4497 4.57629 13.4725C4.58662 13.4953 4.59213 13.52 4.5925 13.545V14.1125C3.50372 13.5058 2.59669 12.6193 1.96513 11.5447C1.33357 10.4701 1.00039 9.24643 1 8C1 7.9675 1 7.9325 1.0025 7.9C1.08816 8.35651 1.35049 8.76079 1.7325 9.025L3.3975 10.275C3.41944 10.2906 3.44557 10.2994 3.4725 10.3C3.49454 10.2996 3.51609 10.2935 3.53503 10.2822C3.55397 10.2709 3.56964 10.2549 3.58049 10.2357C3.59135 10.2165 3.59701 10.1948 3.59692 10.1728C3.59684 10.1507 3.59101 10.1291 3.58 10.11L2.82 8.8425C2.8075 8.8175 2.8075 8.8075 2.805 8.8075C2.81505 8.79644 2.82688 8.78714 2.84 8.78L3.0475 8.665C3.06732 8.65325 3.0836 8.63636 3.0946 8.61611C3.1056 8.59587 3.11092 8.57302 3.11 8.55C3.10914 8.52743 3.10217 8.50551 3.08984 8.48659C3.07752 8.46766 3.0603 8.45242 3.04 8.4425L2.5225 8.1925C2.50736 8.18493 2.49479 8.17307 2.48634 8.1584C2.47789 8.14373 2.47395 8.12689 2.475 8.11L2.4875 7.81C2.48754 7.79862 2.49001 7.78737 2.49475 7.77702C2.4995 7.76667 2.5064 7.75746 2.515 7.75C2.53228 7.73494 2.55459 7.72691 2.5775 7.7275L3.2125 7.755C3.22394 7.7547 3.23529 7.75703 3.24569 7.7618C3.25609 7.76656 3.26526 7.77364 3.2725 7.7825L3.825 8.3825C3.86882 8.43221 3.92671 8.46744 3.991 8.48351C4.05529 8.49958 4.12295 8.49574 4.185 8.4725C4.24835 8.45019 4.3036 8.40948 4.34368 8.35559C4.38376 8.30171 4.40685 8.23709 4.41 8.17L4.4225 7.835C4.42284 7.82367 4.42545 7.81252 4.43017 7.80221C4.4349 7.79191 4.44164 7.78265 4.45 7.775L5.26 7.03C5.27865 7.0153 5.30131 7.00659 5.325 7.005L5.9275 7.0325C6.01584 7.03564 6.10192 7.00425 6.1675 6.945C6.20022 6.91538 6.22677 6.8796 6.24565 6.8397C6.26452 6.79981 6.27535 6.75658 6.2775 6.7125L6.2925 6.3575C6.29258 6.34648 6.29509 6.33562 6.29984 6.32568C6.30459 6.31575 6.31148 6.30698 6.32 6.3L7.015 5.66C7.07773 5.60033 7.11529 5.51895 7.12 5.4325L7.155 4.845C7.1625 4.6775 7.0375 4.4175 6.8325 4.4075L6.1375 4.3825C6.09102 4.38146 6.0448 4.38977 6.00159 4.40692C5.95838 4.42408 5.91905 4.44974 5.88595 4.48239C5.85284 4.51503 5.82662 4.55399 5.80885 4.59695C5.79108 4.63991 5.78212 4.68601 5.7825 4.7325C5.78139 4.74216 5.77782 4.75137 5.77213 4.75924C5.76644 4.76712 5.75882 4.77341 5.75 4.7775C5.73309 4.78731 5.71414 4.79309 5.69463 4.79439C5.67512 4.79569 5.65557 4.79248 5.6375 4.785C5.4575 4.7 5.3875 4.395 5.3425 4.195L5.32 4.11C5.31706 4.09699 5.31711 4.08348 5.32014 4.07049C5.32317 4.0575 5.32911 4.04537 5.3375 4.035C5.34608 4.02415 5.35715 4.01553 5.36977 4.00988C5.3824 4.00422 5.3962 4.00169 5.41 4.0025L6.4675 4.0475C6.56697 4.05226 6.66639 4.03722 6.76 4.00325C6.85361 3.96928 6.93953 3.91705 7.01279 3.84961C7.08606 3.78216 7.14519 3.70083 7.18677 3.61035C7.22835 3.51986 7.25154 3.42202 7.255 3.3225L7.285 2.615C7.28839 2.52589 7.25637 2.43906 7.19595 2.37348C7.13552 2.3079 7.05159 2.2689 6.9625 2.265L6.635 2.2525C6.6137 2.25203 6.59336 2.24352 6.57806 2.22868C6.56276 2.21385 6.55363 2.19378 6.5525 2.1725C6.5525 1.5675 6.2425 1.4875 6.11 1.4825C5.90077 1.48252 5.69916 1.56103 5.545 1.7025C5.45669 1.79394 5.33696 1.84844 5.21 1.855C5.16255 1.85352 5.11647 1.83866 5.0771 1.81212C5.03773 1.78557 5.00667 1.74844 4.9875 1.705C4.985 1.7 4.9825 1.6925 4.98 1.6875C5.92177 1.23303 6.95431 0.997969 8 1C8.14 1 8.2775 1.005 8.415 1.015L8.5975 1.495C8.62545 1.56732 8.67447 1.62957 8.73821 1.6737C8.80195 1.71783 8.87748 1.7418 8.955 1.7425H9.9C9.93108 1.74158 9.96139 1.75228 9.985 1.7725L10.6425 2.31C10.6596 2.32419 10.6728 2.34241 10.6811 2.363C10.6894 2.3836 10.6925 2.40593 10.69 2.42799C10.6875 2.45005 10.6796 2.47115 10.6669 2.48939C10.6543 2.50763 10.6373 2.52245 10.6175 2.5325L10.5425 2.575C10.4956 2.59982 10.4544 2.63423 10.4217 2.67602C10.3889 2.7178 10.3654 2.76601 10.3525 2.8175C10.3393 2.86903 10.3369 2.92274 10.3456 2.97524C10.3542 3.02773 10.3736 3.07787 10.4025 3.1225L10.8725 3.8325C10.912 3.89235 10.9674 3.93997 11.0325 3.97L11.5175 4.19C11.5407 4.20096 11.5603 4.2183 11.574 4.23999C11.5878 4.26168 11.595 4.28683 11.595 4.3125V5.1825C11.5952 5.23931 11.6078 5.29538 11.632 5.34678C11.6562 5.39818 11.6913 5.44365 11.735 5.48C11.7497 5.49057 11.7619 5.50417 11.7709 5.51987C11.7798 5.53557 11.7853 5.55301 11.787 5.57102C11.7887 5.58902 11.7864 5.60717 11.7805 5.62425C11.7745 5.64132 11.765 5.65693 11.7525 5.67L11.2775 6.2125C11.1996 6.30218 11.1588 6.41824 11.1637 6.53696C11.1685 6.65567 11.2185 6.76805 11.3035 6.85109C11.3884 6.93414 11.5019 6.98158 11.6207 6.9837C11.7395 6.98582 11.8546 6.94246 11.9425 6.8625L12.995 5.905C13.0479 5.85667 13.0863 5.79467 13.1062 5.72585C13.126 5.65703 13.1265 5.58406 13.1075 5.515C13.102 5.49628 13.0986 5.47699 13.0975 5.4575C13.0978 5.42845 13.1039 5.39975 13.1155 5.37312C13.1271 5.34649 13.1439 5.32247 13.165 5.3025C13.2086 5.26227 13.2657 5.23995 13.325 5.24L13.525 5.2475Z"
              fill="currentColor"
            />
            <path
              d="M9.02761 2.2725H8.45761C8.4431 2.27266 8.42868 2.27012 8.41511 2.265L7.89761 2.105C7.87893 2.10003 7.85939 2.09925 7.84037 2.1027C7.82136 2.10616 7.80334 2.11377 7.78761 2.125C7.77144 2.1362 7.75823 2.15115 7.74909 2.16856C7.73995 2.18597 7.73515 2.20534 7.73511 2.225V2.56C7.73583 2.58941 7.73917 2.61869 7.74511 2.6475L8.09011 4.1825C8.10653 4.25648 8.14371 4.32423 8.19729 4.37782C8.25087 4.4314 8.31863 4.46858 8.39261 4.485C8.42068 4.48987 8.44911 4.49238 8.47761 4.4925C8.539 4.49253 8.59954 4.47805 8.65428 4.45024C8.70902 4.42244 8.75641 4.3821 8.79261 4.3325L9.34511 3.5925C9.3962 3.52378 9.4242 3.44063 9.42511 3.355V2.6675C9.42471 2.56243 9.38262 2.46181 9.30809 2.38775C9.23356 2.31369 9.13268 2.27224 9.02761 2.2725Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_5_16315">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
      {type === 'pencil' && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <path
            d="M10 18.5C10 18.1022 10.158 17.7206 10.4393 17.4393C10.7206 17.158 11.1022 17 11.5 17C11.8978 17 12.2794 17.158 12.5607 17.4393C12.842 17.7206 13 18.1022 13 18.5C13 18.8978 12.842 19.2794 12.5607 19.5607C12.2794 19.842 11.8978 20 11.5 20C11.1022 20 10.7206 19.842 10.4393 19.5607C10.158 19.2794 10 18.8978 10 18.5ZM10 12.5C10 12.1022 10.158 11.7206 10.4393 11.4393C10.7206 11.158 11.1022 11 11.5 11C11.8978 11 12.2794 11.158 12.5607 11.4393C12.842 11.7206 13 12.1022 13 12.5C13 12.8978 12.842 13.2794 12.5607 13.5607C12.2794 13.842 11.8978 14 11.5 14C11.1022 14 10.7206 13.842 10.4393 13.5607C10.158 13.2794 10 12.8978 10 12.5ZM10 6.5C10 6.10218 10.158 5.72064 10.4393 5.43934C10.7206 5.15804 11.1022 5 11.5 5C11.8978 5 12.2794 5.15804 12.5607 5.43934C12.842 5.72064 13 6.10218 13 6.5C13 6.89782 12.842 7.27936 12.5607 7.56066C12.2794 7.84196 11.8978 8 11.5 8C11.1022 8 10.7206 7.84196 10.4393 7.56066C10.158 7.27936 10 6.89782 10 6.5Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'ant-right' && (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g id="ant-design:left-outlined">
            <path
              id="Vector"
              d="M4.68748 12.5888L4.68748 13.7966C4.68748 13.9013 4.80779 13.9591 4.88904 13.8951L11.9328 8.3935C11.9926 8.34696 12.0411 8.28736 12.0744 8.21926C12.1077 8.15115 12.125 8.07634 12.125 8.00053C12.125 7.92472 12.1077 7.8499 12.0744 7.7818C12.0411 7.7137 11.9926 7.6541 11.9328 7.60756L4.88904 2.106C4.80623 2.04194 4.68748 2.09975 4.68748 2.20444L4.68748 3.41225C4.68748 3.48881 4.72341 3.56225 4.78279 3.60912L10.4078 7.99975L4.78279 12.3919C4.72341 12.4388 4.68748 12.5122 4.68748 12.5888Z"
              fill="currentColor"
            />
          </g>
        </svg>
      )}
      {type === 'ant-left' && (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <path
            d="M11.3125 3.41119V2.20338C11.3125 2.09869 11.1922 2.04088 11.111 2.10494L4.06721 7.6065C4.00736 7.65304 3.95894 7.71264 3.92563 7.78074C3.89232 7.84885 3.875 7.92366 3.875 7.99947C3.875 8.07528 3.89232 8.1501 3.92563 8.2182C3.95894 8.2863 4.00736 8.3459 4.06721 8.39244L11.111 13.894C11.1938 13.9581 11.3125 13.9003 11.3125 13.7956V12.5878C11.3125 12.5112 11.2766 12.4378 11.2172 12.3909L5.59221 8.00025L11.2172 3.60807C11.2766 3.56119 11.3125 3.48775 11.3125 3.41119Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'arrows' && (
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g id="arrows">
            <path
              id="cross"
              d="M7.40992 5.99967L10.9999 2.43966C11.1909 2.24606 11.2971 1.98452 11.2952 1.71259C11.2933 1.44067 11.1835 1.18062 10.9899 0.989665C10.7963 0.798709 10.5348 0.692485 10.2628 0.69436C9.99092 0.696236 9.73088 0.806057 9.53992 0.999665L5.99992 4.58967L2.45992 1.06967C2.27256 0.883415 2.0191 0.778873 1.75492 0.778873C1.49073 0.778873 1.23728 0.883415 1.04992 1.06967C0.956191 1.16263 0.881796 1.27323 0.831028 1.39509C0.780259 1.51695 0.754121 1.64765 0.754121 1.77967C0.754121 1.91168 0.780259 2.04238 0.831028 2.16424C0.881796 2.2861 0.956191 2.3967 1.04992 2.48967L4.58992 5.99967L0.999919 9.55967C0.808963 9.75327 0.702739 10.0148 0.704614 10.2867C0.70649 10.5587 0.816311 10.8187 1.00992 11.0097C1.20353 11.2006 1.46506 11.3068 1.73699 11.305C2.00892 11.3031 2.26896 11.1933 2.45992 10.9997L5.99992 7.40967L9.53992 10.9297C9.72728 11.1159 9.98073 11.2205 10.2449 11.2205C10.5091 11.2205 10.7626 11.1159 10.9499 10.9297C11.0436 10.8367 11.118 10.7261 11.1688 10.6042C11.2196 10.4824 11.2457 10.3517 11.2457 10.2197C11.2457 10.0877 11.2196 9.95695 11.1688 9.83509C11.118 9.71323 11.0436 9.60263 10.9499 9.50967L7.40992 5.99967Z"
              fill="currentColor"
            />
          </g>
        </svg>
      )}
      {type === 'group-empty' && (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g id="Group 628893">
            <rect
              id="Rectangle 1175"
              x="0.75"
              y="0.75"
              width="16.5"
              height="16.5"
              stroke="currentColor"
              strokeWidth="1.5"
            />
          </g>
        </svg>
      )}
      {type === 'group-fill' && (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g id="Group 628892">
            <rect
              id="Rectangle 1175"
              width="18"
              height="18"
              fill="currentColor"
            />
            <path
              id="Vector"
              d="M14.6705 6.61306L8.73563 13.1375C8.29615 13.6208 7.58324 13.6208 7.14334 13.1375L4.07974 9.76908C3.64009 9.28581 3.64009 8.50193 4.07974 8.01856C4.51947 7.53511 5.23232 7.53511 5.67186 8.01838L7.93972 10.5118L13.0781 4.86245C13.5178 4.379 14.2307 4.37937 14.6703 4.86245C15.1099 5.34582 15.1099 6.12943 14.6705 6.61306Z"
              fill="white"
            />
          </g>
        </svg>
      )}
      {type === 'ellip' && (
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <circle cx="4" cy="4" r="4" fill="currentColor" />
        </svg>
      )}
      {type === 'cross' && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <path
            d="M13.4099 12L16.9999 8.44003C17.1909 8.24642 17.2971 7.98489 17.2952 7.71296C17.2933 7.44103 17.1835 7.18099 16.9899 6.99003C16.7963 6.79908 16.5348 6.69285 16.2628 6.69473C15.9909 6.6966 15.7309 6.80642 15.5399 7.00003L11.9999 10.59L8.45992 7.07003C8.27256 6.88378 8.0191 6.77924 7.75492 6.77924C7.49073 6.77924 7.23728 6.88378 7.04992 7.07003C6.95619 7.16299 6.8818 7.2736 6.83103 7.39546C6.78026 7.51731 6.75412 7.64802 6.75412 7.78003C6.75412 7.91204 6.78026 8.04275 6.83103 8.16461C6.8818 8.28647 6.95619 8.39707 7.04992 8.49003L10.5899 12L6.99992 15.56C6.80896 15.7536 6.70274 16.0152 6.70461 16.2871C6.70649 16.559 6.81631 16.8191 7.00992 17.01C7.20353 17.201 7.46506 17.3072 7.73699 17.3053C8.00892 17.3035 8.26896 17.1936 8.45992 17L11.9999 13.41L15.5399 16.93C15.7273 17.1163 15.9807 17.2208 16.2449 17.2208C16.5091 17.2208 16.7626 17.1163 16.9499 16.93C17.0436 16.8371 17.118 16.7265 17.1688 16.6046C17.2196 16.4827 17.2457 16.352 17.2457 16.22C17.2457 16.088 17.2196 15.9573 17.1688 15.8355C17.118 15.7136 17.0436 15.603 16.9499 15.51L13.4099 12Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'like' && (
        <svg
          width="13"
          height="14"
          viewBox="0 0 13 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <path
            d="M0 5.375V11.875C0 12.3237 0.363751 12.6875 0.8125 12.6875H3.25V4.5625H0.8125C0.363751 4.5625 0 4.92625 0 5.375Z"
            fill="currentColor"
          />
          <path
            d="M11.4996 5.37494H9.09937C8.8895 5.37494 8.78437 5.2349 8.74906 5.1746C8.71375 5.11469 8.64234 4.95481 8.7439 4.77152L9.59012 3.24768C9.77579 2.91403 9.79483 2.52167 9.64288 2.17136C9.49094 1.82065 9.19101 1.56635 8.82006 1.47391L8.22338 1.32474C8.07818 1.28824 7.92425 1.33466 7.82309 1.44693L4.5834 5.04605C4.24738 5.42017 4.0625 5.90259 4.0625 6.40485V10.6562C4.0625 11.7762 4.97378 12.6874 6.09375 12.6874L10.1352 12.687C11.0477 12.687 11.8535 12.0725 12.0943 11.193L12.9615 7.21298C12.9869 7.10229 13 6.98882 13 6.87536C13 6.04818 12.3268 5.37494 11.4996 5.37494Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'time' && (
        <svg
          width="13"
          height="14"
          viewBox="0 0 13 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g id="time 1" clipPath="url(#clip0_108_2203)">
            <g id="Group">
              <path
                id="Vector"
                d="M6.88086 6.84693L7.34845 7.33387C8.0241 6.77312 8.89126 6.43552 9.83585 6.43552C10.1286 6.43552 10.4139 6.46818 10.6884 6.52965C10.4676 4.55096 8.87164 2.98189 6.88086 2.80273V6.84693Z"
                fill="currentColor"
              />
              <path
                id="Vector_2"
                d="M6.81208 7.87507L6.11914 7.15344V2.80273C5.24251 2.88162 4.44245 3.22991 3.80258 3.76415L4.43498 4.39655L3.89637 4.93517L3.26397 4.30276C2.72972 4.94263 2.38144 5.74269 2.30255 6.61933H3.19879V7.38104H2.30255C2.38144 8.25768 2.72972 9.05774 3.26397 9.69761L3.87093 9.09065L4.40954 9.62926L3.80258 10.2362C4.42056 10.7522 5.18794 11.0947 6.02944 11.1886C5.96799 10.9141 5.93532 10.6288 5.93532 10.336C5.93534 9.40369 6.26433 8.54683 6.81208 7.87507Z"
                fill="currentColor"
              />
              <path
                id="Vector_3"
                d="M6.29561 11.972C3.64594 11.8644 1.52344 9.67561 1.52344 7C1.52344 4.25591 3.75591 2.02344 6.5 2.02344C9.17561 2.02344 11.3644 4.14594 11.472 6.79561C12.0471 7.06244 12.5465 7.46526 12.929 7.96263C12.9762 7.64528 13 7.32368 13 7C13 5.26379 12.3239 3.6315 11.0962 2.40379C9.8685 1.17613 8.23621 0.5 6.5 0.5C4.76379 0.5 3.1315 1.17613 1.90379 2.40379C0.676127 3.6315 0 5.26379 0 7C0 8.73621 0.676127 10.3685 1.90379 11.5962C3.1315 12.8239 4.76379 13.5 6.5 13.5C6.82368 13.5 7.14525 13.4761 7.46261 13.429C6.96526 13.0465 6.56244 12.547 6.29561 11.972Z"
                fill="currentColor"
              />
            </g>
            <g id="Group_2">
              <path
                id="Vector_4"
                d="M9.83584 7.17188C8.0911 7.17188 6.67166 8.59134 6.67166 10.3361C6.67166 12.0808 8.0911 13.5002 9.83584 13.5002C11.5806 13.5002 13 12.0808 13 10.3361C13 8.59134 11.5806 7.17188 9.83584 7.17188ZM9.83582 12.1232C9.58706 12.1232 9.38541 11.9216 9.38541 11.6728C9.38541 11.4241 9.58706 11.2224 9.83582 11.2224C10.0846 11.2224 10.2862 11.4241 10.2862 11.6728C10.2862 11.9216 10.0846 12.1232 9.83582 12.1232ZM10.1517 10.683H9.51998L9.36205 8.35495H10.3096L10.1517 10.683Z"
                fill="currentColor"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_108_2203">
              <rect
                width="13"
                height="13"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
      {type === 'hour' && (
        <svg
          width="13"
          height="14"
          viewBox="0 0 13 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g id="hour-glass 1" clipPath="url(#clip0_108_2138)">
            <path
              id="Vector"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.88519 7.88978C5.42946 7.40183 5.42946 6.59817 4.88519 6.11021L4.81082 6.04359C3.41574 4.79348 2.33807 3.82816 2.01322 1.80476C1.89828 1.09129 2.54934 0.5 3.33292 0.5H6.49997H9.66712C10.4507 0.5 11.1017 1.09129 10.9868 1.80476C10.662 3.82816 9.58425 4.79348 8.18919 6.04359L8.11484 6.11021C7.57055 6.59817 7.57055 7.40183 8.11484 7.88978L8.18919 7.95641C9.58425 9.20655 10.662 10.1719 10.9868 12.1953C11.1017 12.9087 10.4507 13.5 9.66712 13.5H6.49997H3.33292C2.54934 13.5 1.89828 12.9087 2.01322 12.1953C2.33807 10.1719 3.41574 9.20655 4.81082 7.95641L4.88519 7.88978ZM5.35808 8.99322L5.35303 8.99732C4.2899 9.88983 3.49889 10.5543 3.39579 12.1976C3.38937 12.2987 3.43602 12.3895 3.51208 12.4496C3.57124 12.4967 3.64864 12.525 3.73315 12.525H6.49997H9.26648C9.36624 12.525 9.45617 12.4855 9.518 12.4224C9.5758 12.3637 9.60931 12.2845 9.60384 12.1976C9.50076 10.5543 8.70973 9.88983 7.64698 8.99732C7.36569 8.76124 7.06551 8.50917 6.75418 8.21881C6.61392 8.08797 6.38574 8.08797 6.24548 8.21881C5.93581 8.50748 5.63736 8.75838 5.35808 8.99322Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_108_2138">
              <rect
                width="13"
                height="13"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
      {type === 'completed' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          fill="none"
          viewBox="0 0 13 14"
          className="top-1"
        >
          <g clipPath="url(#clip0_5_9473)">
            <path
              fill="currentColor"
              d="M6.5 13.284A6.283 6.283 0 106.5.716a6.283 6.283 0 000 12.566z"
            ></path>
            <path
              fill="#fff"
              d="M5.257 9.615L3.783 8.176a.332.332 0 010-.477l.489-.476a.351.351 0 01.489 0l.877.857 2.46-3.74a.35.35 0 01.476-.101l.582.365a.333.333 0 01.104.467l-2.913 4.43a.715.715 0 01-1.09.114z"
            ></path>
          </g>
          <defs>
            <clipPath id="clip0_5_9473">
              <path
                width="14"
                height="14"
                fill="#fff"
                d="M0 0H13V13H0z"
                transform="translate(0 .5)"
              ></path>
            </clipPath>
          </defs>
        </svg>
      )}
      {type === 'expired' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="14"
          fill="none"
          viewBox="0 0 13 14"
          className={`${className}`}
        >
          <g fill="currentColor" clipPath="url(#clip0_5_9451)">
            <path d="M6.88 6.847l.468.487a3.883 3.883 0 013.34-.804 4.222 4.222 0 00-3.807-3.727v4.044zM6.812 7.875l-.693-.722v-4.35a4.196 4.196 0 00-2.316.961l.632.633-.539.538-.632-.632a4.196 4.196 0 00-.962 2.316H3.2v.762h-.897c.08.877.428 1.677.962 2.317l.607-.607.538.538-.606.607a4.197 4.197 0 002.226.953 3.9 3.9 0 01.783-3.314z"></path>
            <path d="M6.296 11.972A4.982 4.982 0 011.523 7 4.982 4.982 0 016.5 2.023a4.982 4.982 0 014.972 4.773c.575.266 1.075.67 1.457 1.167.047-.318.071-.64.071-.963a6.457 6.457 0 00-1.904-4.596A6.458 6.458 0 006.5.5a6.458 6.458 0 00-4.596 1.904A6.458 6.458 0 000 7c0 1.736.676 3.368 1.904 4.596A6.457 6.457 0 006.5 13.5c.324 0 .645-.024.963-.071a3.925 3.925 0 01-1.167-1.457z"></path>
            <path d="M9.836 7.172a3.168 3.168 0 00-3.164 3.164A3.168 3.168 0 009.836 13.5 3.168 3.168 0 0013 10.336a3.168 3.168 0 00-3.164-3.164zm0 4.951a.45.45 0 110-.9.45.45 0 010 .9zm.316-1.44H9.52l-.158-2.328h.947l-.157 2.328z"></path>
          </g>
          <defs>
            <clipPath id="clip0_5_9451">
              <path
                fill="#fff"
                d="M0 0H13V13H0z"
                transform="translate(0 .5)"
              ></path>
            </clipPath>
          </defs>
        </svg>
      )}
      {type === 'search' && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.325 14.8992L21.705 20.2792C21.8941 20.4685 22.0003 20.7251 22.0002 20.9926C22.0001 21.2601 21.8937 21.5166 21.7045 21.7057C21.5153 21.8948 21.2587 22.001 20.9912 22.0009C20.7236 22.0008 20.4671 21.8945 20.278 21.7052L14.898 16.3252C13.2897 17.5709 11.2673 18.1571 9.24214 17.9646C7.21699 17.7721 5.34124 16.8153 3.99649 15.2888C2.65174 13.7624 1.939 11.781 2.00326 9.74778C2.06753 7.71451 2.90396 5.78209 4.34242 4.34364C5.78087 2.90518 7.71329 2.06875 9.74656 2.00448C11.7798 1.94022 13.7612 2.65296 15.2876 3.99771C16.814 5.34246 17.7708 7.21821 17.9634 9.24336C18.1559 11.2685 17.5697 13.2909 16.324 14.8992H16.325ZM10 16.0002C11.5913 16.0002 13.1174 15.3681 14.2427 14.2429C15.3679 13.1177 16 11.5915 16 10.0002C16 8.40893 15.3679 6.88281 14.2427 5.75759C13.1174 4.63237 11.5913 4.00023 10 4.00023C8.40871 4.00023 6.88259 4.63237 5.75737 5.75759C4.63215 6.88281 4.00001 8.40893 4.00001 10.0002C4.00001 11.5915 4.63215 13.1177 5.75737 14.2429C6.88259 15.3681 8.40871 16.0002 10 16.0002Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'play-circle-sharp' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100"
          height="100"
          fill="none"
          viewBox="0 0 100 100"
          className={`${className}`}
        >
          <g>
            <path
              fill="currentColor"
              d="M50 9.375C27.6 9.375 9.375 27.6 9.375 50S27.6 90.625 50 90.625 90.625 72.4 90.625 50 72.4 9.375 50 9.375zM39.062 67.188V32.812L67.189 50 39.061 67.188z"
            ></path>
          </g>
        </svg>
      )}
      {type === 'learning-resource' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          className={`${className}`}
        >
          <path
            fill="currentColor"
            d="M21.938 2.25H2.063a.563.563 0 00-.563.563v2.624c0 .311.252.563.563.563h19.875c.31 0 .562-.252.562-.563V2.813a.562.562 0 00-.563-.562zM3 7.5v13.125a1.125 1.125 0 001.125 1.125h15.75A1.125 1.125 0 0021 20.625V7.5H3zm9 10.81l-4.063-4.06L9 13.187l2.25 2.252V9.75h1.5v5.69l2.253-2.254 1.06 1.061L12 18.311z"
          ></path>
        </svg>
      )}
      {type === 'entrance-test' && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <path
            d="M7.5 11.25H14.408L11.408 8.25L12.4688 7.18922L17.2795 12L12.4688 16.8108L11.408 15.75L14.408 12.75H7.5V19.6875C7.5 19.8367 7.55926 19.9798 7.66475 20.0852C7.77024 20.1907 7.91332 20.25 8.0625 20.25H21.9375C22.0867 20.25 22.2298 20.1907 22.3352 20.0852C22.4407 19.9798 22.5 19.8367 22.5 19.6875V4.3125C22.5 4.16332 22.4407 4.02024 22.3352 3.91475C22.2298 3.80926 22.0867 3.75 21.9375 3.75H8.0625C7.91332 3.75 7.77024 3.80926 7.66475 3.91475C7.55926 4.02024 7.5 4.16332 7.5 4.3125V11.25Z"
            fill="currentColor"
            className="group-resource"
          />
          <path
            d="M7.5 11.25H1.5V12.75H7.5V11.25Z"
            fill="currentColor"
            className="group-resource"
          />
        </svg>
      )}

      {type === 'event-test' && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <path
            className="group-resource"
            d="M3.75 1.5L0.75 7.5H14.302L18.0623 1.5H3.75Z"
            fill="currentColor"
          />
          <path
            className="group-resource"
            d="M23.2501 6.75L19.8751 1.5L13.9689 10.8319C12.6938 10.3889 11.3065 10.3889 10.0314 10.8319L8.88436 9H2.0542L6.11639 15.323C5.94174 16.1936 5.96253 17.0922 6.17725 17.9538C6.39197 18.8155 6.79528 19.6187 7.35806 20.3056C7.92085 20.9925 8.62909 21.5459 9.43168 21.9259C10.2343 22.3059 11.1112 22.503 11.9992 22.503C12.8872 22.503 13.7641 22.3059 14.5667 21.9259C15.3693 21.5459 16.0775 20.9925 16.6403 20.3056C17.2031 19.6187 17.6064 18.8155 17.8212 17.9538C18.0359 17.0922 18.0567 16.1936 17.882 15.323L23.2501 6.75ZM12.0001 19.7812C11.3512 19.7812 10.7168 19.5888 10.1772 19.2283C9.63757 18.8677 9.21701 18.3552 8.96866 17.7557C8.72031 17.1561 8.65533 16.4964 8.78194 15.8599C8.90854 15.2234 9.22105 14.6387 9.67994 14.1798C10.1388 13.7209 10.7235 13.4084 11.36 13.2818C11.9965 13.1552 12.6562 13.2202 13.2558 13.4685C13.8554 13.7169 14.3678 14.1374 14.7284 14.677C15.0889 15.2166 15.2814 15.851 15.2814 16.5C15.2804 17.3699 14.9344 18.204 14.3192 18.8191C13.7041 19.4342 12.8701 19.7803 12.0001 19.7812Z"
            fill="currentColor"
          />
          <path
            className="group-resource"
            d="M12 18C12.8284 18 13.5 17.3284 13.5 16.5C13.5 15.6716 12.8284 15 12 15C11.1716 15 10.5 15.6716 10.5 16.5C10.5 17.3284 11.1716 18 12 18Z"
            fill="currentColor"
          />
        </svg>
      )}

      {type === 'circle' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className={`${className}`}
        >
          <circle cx="8" cy="8" r="8" fill="currentColor" />
        </svg>
      )}

      {type === 'arrow-bottom' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          className={`${className}`}
        >
          <path
            stroke="currentColor"
            strokeLinecap="square"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M19 9.391l-7 7.305L5 9.39"
          ></path>
        </svg>
      )}
      {type === 'volume' && (
        <svg
          className={className}
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="none"
          viewBox="0 0 16 16"
        >
          <g fill="#fff" clipPath="url(#clip0_246_5900)">
            <path d="M9.298.586a.532.532 0 00-.564.064L3.546 4.8h-2.48C.48 4.8 0 5.28 0 5.867v4.267c0 .588.479 1.066 1.067 1.066h2.479l5.187 4.15a.539.539 0 00.565.064.532.532 0 00.302-.48V1.067a.535.535 0 00-.302-.481zM12.3 4.229a.535.535 0 00-.75.759A4.197 4.197 0 0112.8 8a4.197 4.197 0 01-1.25 3.013.534.534 0 10.75.757A5.246 5.246 0 0013.867 8 5.254 5.254 0 0012.3 4.23z"></path>
            <path d="M13.805 2.726a.534.534 0 00-.752.757A6.315 6.315 0 0114.933 8c0 1.711-.668 3.314-1.88 4.517a.536.536 0 00-.004.755.536.536 0 00.756.002A7.367 7.367 0 0016 8c0-1.998-.779-3.87-2.195-5.274z"></path>
          </g>
          <defs>
            <clipPath id="clip0_246_5900">
              <path fill="#fff" d="M0 0H16V16H0z"></path>
            </clipPath>
          </defs>
        </svg>
      )}
      {type === 'fullscreen' && (
        <svg
          className={className}
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M5.45457 16H0.363649C0.162648 16 0 15.8374 0 15.6364V10.5455C0 10.3445 0.162648 10.1818 0.363649 10.1818H1.09091C1.29191 10.1818 1.45456 10.3445 1.45456 10.5455V14.5454H5.45457C5.65557 14.5454 5.81822 14.7081 5.81822 14.9091V15.6364C5.81822 15.8374 5.65557 16 5.45457 16Z"
            fill="currentColor"
          />
          <path
            d="M15.6364 16H10.5455C10.3445 16 10.1818 15.8374 10.1818 15.6364V14.9091C10.1818 14.7081 10.3445 14.5454 10.5455 14.5454H14.5454V10.5455C14.5454 10.3445 14.7081 10.1818 14.9091 10.1818H15.6364C15.8374 10.1818 16 10.3445 16 10.5455V15.6364C16 15.8374 15.8374 16 15.6364 16Z"
            fill="currentColor"
          />
          <path
            d="M15.6364 5.81819H14.9091C14.7081 5.81819 14.5455 5.65554 14.5455 5.45454V1.45456H10.5455C10.3445 1.45456 10.1818 1.29191 10.1818 1.09091V0.363648C10.1818 0.162648 10.3445 0 10.5455 0H15.6364C15.8374 0 16 0.162648 16 0.363648V5.45457C16 5.65557 15.8374 5.81819 15.6364 5.81819Z"
            fill="currentColor"
          />
          <path
            d="M5.45457 1.45455H1.45456V5.45457C1.45456 5.65557 1.29191 5.81822 1.09091 5.81822H0.363649C0.162648 5.81819 0 5.65557 0 5.45457V0.363682C0 0.162682 0.162648 3.37299e-05 0.363649 3.37299e-05H5.45457C5.65557 3.37299e-05 5.81822 0.162682 5.81822 0.363682V1.09094C5.81822 1.29191 5.65557 1.45455 5.45457 1.45455Z"
            fill="currentColor"
          />
        </svg>
      )}
    </>
  )
}
export const TimeIcon = () => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 164 164"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="100" height="100" rx="82" fill="#FFFAF0" />
      <path
        d="M84.9184 53.0586H79.0938C78.5609 53.0586 78.125 53.4945 78.125 54.0274V87.3645C78.125 87.6793 78.2703 87.9699 78.5246 88.1516L98.5414 102.768C98.9773 103.082 99.5828 102.998 99.8977 102.562L103.361 97.8391C103.688 97.391 103.591 96.7856 103.155 96.4828L85.8871 83.9981V54.0274C85.8871 53.4945 85.4512 53.0586 84.9184 53.0586ZM111.535 62.1649L130.522 66.8027C131.128 66.9481 131.721 66.4879 131.721 65.8703L131.818 46.3137C131.818 45.5024 130.886 45.0422 130.256 45.5508L111.171 60.4574C111.027 60.569 110.917 60.719 110.855 60.8903C110.792 61.0615 110.779 61.2469 110.817 61.4253C110.855 61.6036 110.942 61.7677 111.069 61.8985C111.196 62.0293 111.358 62.1217 111.535 62.1649ZM131.842 98.6262L124.976 96.2649C124.737 96.1828 124.475 96.1977 124.246 96.3063C124.018 96.4149 123.841 96.6087 123.753 96.8461C123.523 97.4637 123.281 98.0692 123.027 98.6746C120.871 103.773 117.783 108.362 113.836 112.298C109.932 116.214 105.305 119.335 100.213 121.489C94.9368 123.719 89.2658 124.864 83.5379 124.855C77.7496 124.855 72.143 123.729 66.8633 121.489C61.7706 119.335 57.1441 116.214 53.2402 112.298C49.3047 108.362 46.2168 103.773 44.0492 98.6746C41.831 93.3959 40.6945 87.7258 40.707 82C40.707 76.2117 41.8332 70.593 44.0734 65.3133C46.2289 60.2153 49.3168 55.6258 53.2645 51.6903C57.1683 47.7743 61.7948 44.653 66.8875 42.4992C72.143 40.259 77.7617 39.1328 83.55 39.1328C89.3383 39.1328 94.9449 40.259 100.225 42.4992C105.317 44.653 109.944 47.7743 113.848 51.6903C115.083 52.9375 116.245 54.2332 117.311 55.6016L124.552 49.9344C115.022 37.7524 100.188 29.9176 83.5258 29.9297C54.5117 29.9418 31.2133 53.5067 31.5039 82.5328C31.7945 111.05 54.984 134.07 83.55 134.07C106.013 134.07 125.146 119.83 132.436 99.8856C132.617 99.377 132.351 98.8078 131.842 98.6262Z"
        fill="#FFB800"
      />
    </svg>
  )
}

export const VerifiedIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="verified 1" clipPath="url(#clip0_12314_6902)">
        <g id="Group">
          <path
            id="Vector"
            d="M7 13.5625C10.6244 13.5625 13.5625 10.6244 13.5625 7C13.5625 3.37563 10.6244 0.4375 7 0.4375C3.37563 0.4375 0.4375 3.37563 0.4375 7C0.4375 10.6244 3.37563 13.5625 7 13.5625Z"
            fill="#FFB800"
          />
          <path
            id="Vector_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.13154 7.30932C2.83896 7.01674 2.83896 6.54235 3.13154 6.24977C3.42412 5.95719 3.89851 5.95719 4.19109 6.24977L6.04718 8.10587L9.81096 4.30454C10.1019 4.01196 10.575 4.01065 10.8676 4.30161C11.1602 4.59258 11.1615 5.06565 10.8705 5.35823C9.43994 6.8031 8.01549 8.25899 6.57811 9.69637C6.28553 9.98895 5.81115 9.98895 5.51857 9.69637L3.13154 7.30932Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_12314_6902">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
